<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 18c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Zm0-12c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Zm0 6c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2Z"
    />
  </svg>
</template>
